import Button from 'components/Button';
import FormActionGroup from 'components/FormActionGroup';
import Modal from 'components/Modal';
import Select from 'components/Select';
import Typography from 'components/Typography';
import {PlusComponent} from 'pages/Requests/Requests';
import {useHistory} from 'react-router-dom';
import styles from './SendBulkMessageModal.module.scss';

import {useSendBulkMessage} from './useSendBulkMessage';

type SendBulkMessageModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  count?: number;
  customerIds: number[];
};

function SendBulkMessageModal({
  isOpen,
  onClose,
  title,
  count = 0,
  customerIds,
}: SendBulkMessageModalProps) {
  const {push} = useHistory();
  const {
    handleClose,
    message,
    setMessage,
    selectedTemplate,
    setSelectedTemplate,
    templateOptions,
    handleSendBulkMessage,
    isSending,
  } = useSendBulkMessage({onClose, customer_ids: customerIds});

  return (
    <Modal isOpen={isOpen} onClose={handleClose} className={styles.filterModal}>
      <Typography variant="h2">
        {title || `Send message to ${count} deliveries`}
      </Typography>
      <textarea
        className={styles.messageTextarea}
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <div className={styles.label}>
        <div>Template</div>
        <PlusComponent onClick={() => push('/website/templates/create')} />
      </div>
      <Select
        className={styles.templateSelect}
        placeholder="Select Template"
        options={templateOptions}
        value={selectedTemplate}
        onChange={(option) => {
          setSelectedTemplate(option!);
          setMessage(option?.value as string);
        }}
      />

      <FormActionGroup className={styles.buttonWrap}>
        <Button
          onClick={handleSendBulkMessage}
          color="blue"
          loading={isSending}
          disabled={isSending}
        >
          Send
        </Button>
      </FormActionGroup>
    </Modal>
  );
}

export default SendBulkMessageModal;
